import { render, staticRenderFns } from "./MarketsDetails.vue?vue&type=template&id=f8ac1562&scoped=true"
import script from "./MarketsDetails.vue?vue&type=script&lang=js"
export * from "./MarketsDetails.vue?vue&type=script&lang=js"
import style0 from "./MarketsDetails.vue?vue&type=style&index=0&id=f8ac1562&prod&lang=scss&scoped=true"
import style1 from "./MarketsDetails.vue?vue&type=style&index=1&id=f8ac1562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ac1562",
  null
  
)

export default component.exports